import { initialState } from "./state";

export const hdStations = (state = initialState, action) => {
  switch (action.type) {
    case "SET_HDSTATIONS_LIST": {
      return Object.assign({}, state, {
        hdStationsList: action.data
      });
    }
    default:
      return state;
  }
};
